import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(private auth: AuthenticationService, private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = this.auth.getToken();
    let tokenReq = req;

    if (req.headers.get('skip')) return next.handle(req);

    const isLocalApiHost =
      environment.appBaseUrl.includes('localhost');
    const apiBaseUrl = isLocalApiHost
      ? environment.appBaseUrl
      : `${environment.appBaseUrl}/Diagnosticlearning`;
    const joinedUrl = `${apiBaseUrl.replace(/\/+$/, '')}${req.url.startsWith('/') ? '' : '/'
      }${req.url}`;
    tokenReq = req.clone({
      url: joinedUrl,
      setHeaders: { Authorization: `Bearer ${token}` },
    });

    //refresh token code

    // return next.handle(tokenReq).pipe(catchError(error => {
    //     if (error instanceof HttpErrorResponse && !tokenReq.url.includes('auth/signin') && error.status === 401) {
    //       return this.handle401Error(tokenReq, next);
    //     }

    //     return throwError(error);
    //   }));
    return next.handle(tokenReq).pipe(
      catchError((error) => {
        if (token == null && error instanceof HttpErrorResponse) {
          let msg = 'invalid credentials';
          return throwError(() => msg);
        } else if (error instanceof HttpErrorResponse && error.status === 401) {
          console.log('error', error);
          return this.handle401Error(tokenReq, next);
        }
        return throwError(() => error);
      })
    );
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const token = this.auth.getRefreshToken();

      if (token)
        return this.auth.refreshToken(token).pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;

            this.auth.setToken(token.accessToken);
            this.refreshTokenSubject.next(token.accessToken);
            return next.handle(this.addTokenHeader(request, token.accessToken));
          }),
          catchError((err) => {
            console.log('errir', err);
            this.isRefreshing = false;
            this.auth.logout().subscribe((res) => {});
            this.router.navigate(['']);

            return throwError(() => err);
          })
        );
    }

    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }
  private addTokenHeader(request: HttpRequest<any>, token: string) {
    /* for Spring Boot back-end */
    // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    /* for Node.js Express back-end */
    return request.clone({
      url: `${request.url}`,
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
}
